import { get } from "lodash"
import { createSelector } from "reselect"
import { getDatasetEntitlementsEnabled } from "modules/account-root/selectors"
import { isAllAccessTeam } from "helpers/permissions/teams"
import { getRole } from "helpers/permissions/roles"
import { computeTeamTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"

export const getTeamAlias = (_, props) => props.params.teamAlias
export const getTeamId = (_, props) => get(props, "teamPermissions.team.id")
export const getTeamRole = (_, props) => get(props, "teamPermissions.team.role")
export const getTeamPermissions = (_, props) => get(props, "teamPermissions.team.resourcePermissions")
export const getResources = (_, props) => get(props, "resources.resources")

const getIsAllAccessTeam = createSelector(
  [getTeamAlias],
  (teamAlias) => isAllAccessTeam(teamAlias),
)

export const getTabs = createSelector(
  [getRoute, getPath, getDatasetEntitlementsEnabled, getRole, getTeamRole, getIsAllAccessTeam],
  computeTeamTabs,
)
